import React from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

const VerificationCodeModal = ({
    show,
    onHide,
    onSubmit,
    loading = false,
    error = '',
    code = '',
    onCodeChange,
    timeLeft = 300,
}) => {
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
        const seconds = (timeLeft % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="p-3 pb-0">
                <Modal.Title>Verificación de código</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Se envió un código de 6 dígitos a tu correo. Ingresa el código para continuar.</p>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={onSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Código de verificación</Form.Label>
                        <Form.Control
                            type="text"
                            inputMode="numeric"
                            maxLength={6}
                            value={code}
                            onChange={(e) => onCodeChange?.(e.target.value.replace(/\D/g, '').slice(0, 6))}
                            placeholder="Ingrese el código de 6 dígitos"
                            autoFocus
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={loading || timeLeft <= 0 || code.length !== 6}
                        >
                            {loading ? 'Validando...' : 'Validar'}
                        </Button>
                        <Alert variant="warning" className="mb-0">
                            El código expira en <strong>{formatTimeLeft()}</strong>
                        </Alert>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default VerificationCodeModal;
